import React, { Component } from 'react';
import { CardButton } from './CardButton';
import { CardButtonDescription } from './CardButtonDescription';

export class ArchetypeBox extends Component {

  render() {

    return (
      <div className="CardBox">
        <div className="CardBoxTitleOuter">
          <p className="CardBoxTitle">
            Archetype
          </p>
					<p className="CardBoxTitle CardBoxSubtitle">
            Choose your favorite way to play!
          </p>
        </div>




        <div className="CardBoxContainer">

					<div className="CardBoxBackground ArchetypeBoxBackground" />
					<div className="CardBoxTint" />


          <CardButton rarity="rare"
											titleBackground="rareTitle"
											cardTitle={ "beatdown" }
											className="beatdown"
											cardBackground="golem"
											archetypeName="beatdown"/>
					<div className="cardConnector"/>
					<CardButtonDescription rarity="archetypeDescription"
											titleBackground="rareTitle"
											cardTitle={ "beatdown" }
											className="beatdown"
											cardBackground="golem"
											archetypeName="beatdown"
											text="FIGHT WITH MAXIMUM AGRESSION AND EXTREME AMOUNTS OF YELLING WHILE BUILDING AN UNSTOPPABLE PUSH. FIGHT ON YOUR OPPONENT&#8217;S SIDE OF THE ARENA. *hog rider scream.*"
											color="redDescription"/>

					<CardButtonDescription rarity="archetypeDescription"
											titleBackground="epicTitle"
											cardTitle={ "control" }
											className="control"
											cardBackground="miner legendaryBackground"
											archetypeName="control"
											text="Chip your opponent&#8217;s towers down, mounting bigger and bigger pushes as the battle progresses. Defend when you need to, and convert a good defense into a great offense once you&#8217;ve made those positive elixir trades. Mmm... It&#8217;sa YouTuber reference!"
											color="purpleDescription"/>
					<div className="cardConnector"/>
          <CardButton rarity="epic"
											titleBackground="epicTitle"
											cardTitle={ "control" }
											className="control"
											cardBackground="miner legendaryBackground"
											archetypeName="control"/>



          <CardButton rarity="common"
											titleBackground="commonTitle"
											cardTitle={ "siege" }
											className="siege"
											cardBackground="x-bow"
											archetypeName="siege"/>
					<div className="cardConnector"/>
					<CardButtonDescription rarity="archetypeDescription"
											titleBackground="commonTitle"
											cardTitle={ "siege" }
											className="siege"
											cardBackground="x-bow"
											archetypeName="siege"
											text="We&#8217;re gonna build a wall, and make the Elite Barbarians pay for it. Build a wall of defenses and use them to protect your siege weapon so it can take down your opponent&#8217;s towers from your side of the arena!"
											color="lightBlueDescription"/>

        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/Components/ArchetypeBox.js